import { Page } from '@bonanza-social/navigation';
import { useParams } from 'react-router';
import useGames from '../hooks/useGames';
import GameInfo from '../components/GameInfo/GameInfo';

function GameInfoPage() {
  const { name } = useParams();

  useGames();

  if (!name) {
    return;
  }

  return (
    <Page>
      <GameInfo
        name={name}
        width="100%"
        maxWidth="max-page-width"
        marginHorizontal="auto"
      />
    </Page>
  );
}

export default GameInfoPage;
